import { Container } from 'inversify'

import {
  SoccerEventStatusId,
  SoccerIncidentId,
} from '@collector/sportsapi-client-legacy'
import { RelationSportCommonIoCBindings } from '@mobile/views/Relation/Shared/RelationSportCommonDependencies/relationSportCommonDependencies'

export function bindIncidentsResultConfiguration(ioc: Container): void {
  ioc
    .bind(RelationSportCommonIoCBindings.IncidentsResultConfiguration)
    .toDynamicValue(() => {
      return {
        isResultVisible: (incident) =>
          incident.event_status_id !== SoccerEventStatusId.PenaltyShootout,
        scoringIncidents: new Map([
          [SoccerIncidentId.Goal, { add: 1, visible: true }],
        ]),
      }
    })
    .inSingletonScope()
}
